import _ from 'lodash'
import React, { useEffect, useState } from 'react'
import { useAppDispatch, useAppSelector } from '../../hooks/hooks'
import { selectCurrent } from '../../redux/settings/selectors'
import { settings } from '../../redux/settings/actions'
import { DeleteModal } from '../../models/delete-modal'
import { FaEdit, FaTrash } from 'react-icons/fa';
import { YesNoRendererComponent } from './yes-no-renderer.component'
import { format } from '../services/date.service'
import { MobileLibraryRendererComponent } from './mobile-library-render.component'

const MobileViewTable = ({ onAgentAssignClick, onCargoDriverStatusClick, onCargoDeliveryStatusClick, onCargoTransitStatusClick, onCargoIssueStatusClick, onCargoPickupStatusClick, onCargoOrderStatusClick,
	onShippingStatusClick, onReturnRequestStatusClick, onFullfillmentStatusClick, onPaymentStatusClick, onOrderStatusClick, columnData, rowData, onEdit, additionButtons, onDelete, headingName }: any) => {
	const [deleteData, setDeleteData] = useState({})
	const [visibleTooltip, setVisibleTooltip] = useState<any>({
		row: '',
		column: ''
	});
	const dispatch = useAppDispatch()
	const { getDeleteModal } = useAppSelector(selectCurrent)

	const handleDeleteClose = () => {
		setDeleteData({})
		dispatch(settings.set({ getDeleteModal: 'close' }))
	}
	const handleClickDelete = (data: any) => {
		setDeleteData(data)
		dispatch(settings.set({ getDeleteModal: 'open' }))
	};
	const handleDeleteData = () => {
		handleDelete(deleteData)
		handleDeleteClose()
	};

	const filteredFields = _.filter(
		columnData,
		(item) => item.field !== 'Sl' && item.field !== 'Edit'
	)

	const handleEdit = (item: any) => {
		onEdit(item)
	}

	const handleDelete = (item: any) => {
		onDelete(item)
	}

	const handleTooltipToggle = (rowId: any, columnField: any) => {
		if (visibleTooltip.row === rowId && visibleTooltip.column === columnField) {
			setVisibleTooltip({ row: '', column: '' }); // Close the tooltip if already open
		} else {
			setVisibleTooltip({ row: rowId, column: columnField }); // Open the tooltip for this row and column
		}
	};

	useEffect(() => {
		const handleClickOutside = (event: MouseEvent) => {
			const tooltipElement = document.getElementById('tooltip');
			if (tooltipElement && !tooltipElement.contains(event.target as Node)) {
				setVisibleTooltip({ row: '', column: '' });
			}
		};
		document.addEventListener('mousedown', handleClickOutside);
		return () => {
			document.removeEventListener('mousedown', handleClickOutside);
		};
	}, []);

	return (

		<>
			<div className="pt-10 p-3 m-3">
				<div className="flex my-2  w-full justify-between items-center px-2">
					<div className="uppercase text-xl">
						{headingName ? headingName : ''}
					</div>
					<div className=' flex flex-row items-end justify-end text-end '>

						{/* Add button */}

						{additionButtons?.length && additionButtons.map((button: any) => (
							<button
								onClick={(event) => button.callback(event)}
								type="button"
								className="group flex items-center mr-2 bg-blue-700 text-white rounded font-medium px-4 py-2 "
								title={button.name}
							>
								<span className=''>{button.svg}</span>
								<span className=''>{button.name}</span>
							</button>
						))}


					</div>
				</div>
				<div className="w-full my-3  px-3 flex justify-between items-center">
					<input
						id="search"
						type="text"
						placeholder="Search products..."
						className="w-full px-4 py-2 border rounded-lg"
					// value={searchTerm}
					// onChange={(e) => setSearchTerm(e.target.value)}
					/>

				</div>
				{rowData?.length !== 0 ?
					<>
						{rowData?.map((row: any, index: any) => (
							<div key={rowData} className="bg-white shadow-lg rounded-lg mb-4 border border-gray-200">
								<div className="p-2 m-2 relative ">

									<div key={index} className="absolute top-2 right-2 flex space-x-4">
										{onEdit && <button className="text-blue-500 hover:text-blue-700" onClick={() => handleEdit(row)}>
											<FaEdit />
										</button>}
										{onDelete && <button className="text-red-500 hover:text-red-700" onClick={() => handleClickDelete(row)}>
											<FaTrash />
										</button>}
										{getDeleteModal == 'open' && <DeleteModal onSubmit={handleDeleteData} handleClose={handleDeleteClose} />}
									</div>
									{columnData[0]?.isSortLabel ?
										<>
											{filteredFields.map((column: any, index: any) => {
												const dataValue: any = _.property(column.field)(row)
												const address = `${dataValue?.address?.building} , ${dataValue?.address?.locality} , ${dataValue?.address?.city} , ${dataValue?.address?.country} , ${dataValue?.address?.state} - ${dataValue?.address?.area_code}`;
												return (
													<div className="flex items-center justify-between mt-5 mb-2">


														<span key={index} className="text-gray-700 font-bold">{column?.headerName}:</span>
														{column.cellRenderer !== 'yesNoRenderer' && column.isDateValueFormat !== true && column.cellRenderer !== 'libraryRendererComponent' && column.isAddressFormat !== true &&

															<span className="text-gray-900">{dataValue}</span>
														}
														{column.isDateValueFormat === true && (
															<span className="text-gray-900">
																{format(dataValue)}
															</span>
														)}
														{column.cellRenderer === 'yesNoRenderer' && (
															<YesNoRendererComponent
																cellRenderer={column.cellRenderer}
																value={dataValue} />
														)}

														{column.isAddressFormat === true && (
															<div className="relative">
																<span
																	className="font-semibold truncate text-gray-900"
																	title={address?.length > 15 ? address : ''}
																	onClick={() => handleTooltipToggle(row.Id, column.field)}
																>
																	{address?.length > 15 ? `${address.substring(0, 15)}...` : address}
																</span>


																{visibleTooltip.row === row.Id && visibleTooltip.column === column.field && (
																	<div
																		id="tooltip"
																		onClick={() => setVisibleTooltip({ row: '', column: '' })}
																		className="fixed z-50 bg-gray-900 text-white text-sm rounded pr-10 pl-3 py-3 shadow-lg top-1/3 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-screen"
																	>
																		{address}
																	</div>
																)}
															</div>
														)}
														{column.cellRenderer === 'libraryRendererComponent' &&
															<MobileLibraryRendererComponent
																cellRenderer={column.cellRenderer}
																cellRendererParams={column.cellRendererParams}
																data={column}
																dataId={row}
																onAgentAssignClick={onAgentAssignClick}
																onCargoDriverStatusClick={onCargoDriverStatusClick}
																onCargoDeliveryStatusClick={onCargoDeliveryStatusClick}
																onCargoTransitStatusClick={onCargoTransitStatusClick}
																onCargoIssueStatusClick={onCargoIssueStatusClick}
																onCargoPickupStatusClick={onCargoPickupStatusClick}
																onCargoOrderStatusClick={onCargoOrderStatusClick}
																onOrderStatusClick={onOrderStatusClick}
																onPaymentStatusClick={onPaymentStatusClick}
																onFullfillmentStatusSubmit={onFullfillmentStatusClick}
																onReturnRequestStatusClick={onReturnRequestStatusClick}
																onShippingStatusClick={onShippingStatusClick}
																value={dataValue}
															/>}

													</div>
												)

											})}</>
										:
										<>
											{filteredFields.map((column: any, index: any) => {
												const dataValue: any = _.property(column.field)(row)
												const address = `${dataValue?.address?.building} , ${dataValue?.address?.locality} , ${dataValue?.address?.city} , ${dataValue?.address?.country} , ${dataValue?.address?.state} - ${dataValue?.address?.area_code}`;
												return (
													<div className="flex items-center justify-between mt-5 mb-2">


														<span key={index} className="text-gray-700 font-bold">{column?.headerName}:</span>
														{column.cellRenderer !== 'yesNoRenderer' && column.isDateValueFormat !== true && column.cellRenderer !== 'libraryRendererComponent' && column.isAddressFormat !== true &&

															<span className="text-gray-900">{dataValue}</span>
														}
														{column.isDateValueFormat === true && (
															<span className="text-gray-900">
																{format(dataValue)}
															</span>
														)}
														{column.cellRenderer === 'yesNoRenderer' && (
															<YesNoRendererComponent
																cellRenderer={column.cellRenderer}
																value={dataValue} />
														)}
														{column.isAddressFormat === true && (
															<div className="relative">
																<span
																	className="font-semibold truncate text-gray-900"
																	title={address?.length > 15 ? address : ''}
																	onClick={() => handleTooltipToggle(row.Id, column.field)}
																>
																	{address?.length > 15 ? `${address.substring(0, 15)}...` : address}
																</span>


																{visibleTooltip.row === row.Id && visibleTooltip.column === column.field && (
																	<div
																		id="tooltip"
																		onClick={() => setVisibleTooltip({ row: '', column: '' })}
																		className="fixed z-50 bg-gray-900 text-white text-sm rounded pr-10 pl-3 py-3 shadow-lg top-1/3 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-screen"
																	>
																		{address}
																	</div>
																)}
															</div>
														)}
														{column.cellRenderer === 'libraryRendererComponent' &&
															<MobileLibraryRendererComponent
																cellRenderer={column.cellRenderer}
																cellRendererParams={column.cellRendererParams}
																data={column}
																dataId={row}
																onAgentAssignClick={onAgentAssignClick}
																onCargoDriverStatusClick={onCargoDriverStatusClick}
																onCargoDeliveryStatusClick={onCargoDeliveryStatusClick}
																onCargoTransitStatusClick={onCargoTransitStatusClick}
																onCargoIssueStatusClick={onCargoIssueStatusClick}
																onCargoPickupStatusClick={onCargoPickupStatusClick}
																onCargoOrderStatusClick={onCargoOrderStatusClick}
																onOrderStatusClick={onOrderStatusClick}
																onPaymentStatusClick={onPaymentStatusClick}
																onFullfillmentStatusSubmit={onFullfillmentStatusClick}
																onReturnRequestStatusClick={onReturnRequestStatusClick}
																onShippingStatusClick={onShippingStatusClick}
																value={dataValue}
															/>}

													</div>
												)

											})}</>}
								</div>
							</div>))}</>

					:
					<div className='w-full text-start text-xl p-6 border-2 border-skin-ouprimary rounded-lg'>No Data in the page</div>}



			</div>

		</>


	)
}

export default MobileViewTable